import { useState } from "react";
import { Button, SimpleDialog } from "@powerdiary/components-library/lib";

export interface IConfirmationProps {
    title?: string;
    text?: string;
    yesButtonTitle?: string;
    yesButtonCallback?: () => void;
    noButtonTitle?: string;
    noButtonCallback?: () => void;
    onModalClosed?: () => void;
}

export const ConfirmationDialog = (props: IConfirmationProps) => {
    const [open, setOpen] = useState<boolean>(true);

    const { onModalClosed, noButtonTitle, yesButtonTitle, noButtonCallback, yesButtonCallback, text, title } = props;

    const onDialogClose = (): void => {
        if (onModalClosed) {
            onModalClosed();
        }

        setOpen(false);
    };

    const renderActions = () => (
        <>
            <Button variant="outlined" size="medium" onClick={noButtonCallback}>
                {noButtonTitle || "No"}
            </Button>
            <Button variant="contained" size="medium" onClick={yesButtonCallback}>
                {yesButtonTitle || "Yes"}
            </Button>
        </>
    );

    return (
        <SimpleDialog
            open={open}
            handleClose={onDialogClose}
            dialogTitleText={title || "Confirmation"}
            renderActions={renderActions}
            dialogContentText={text || "Are you sure?"}
        />
    );
};
